const applePhone = /iPhone/i;
const appleIpod = /iPod/i;
const appleMacIntel = 'MacIntel';
const appleTablet = /iPad/i;
const androidPhone = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i; // Match 'Android' AND 'Mobile'
const androidTablet = /Android/i;
const amazonPhone = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i;
const amazonTablet = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i;
const windowsPhone = /Windows Phone/i;
const windowsTablet = /(?=.*\bWindows\b)(?=.*\bARM\b)/i; // Match 'Windows' AND 'ARM'
const otherBlackberry = /BlackBerry/i;
const otherBlackberry10 = /BB10/i;
const otherOpera = /Opera Mini/i;
const otherChrome = /(CriOS|Chrome)(?=.*\bMobile\b)/i;
const otherFirefox = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i; // Match 'Firefox' AND 'Mobile'
const sevenInch = new RegExp(
'(?:' + // Non-capturing group
  'Nexus 7' + // Nexus 7
  '|' + // OR
  'BNTV250' + // B&N Nook Tablet 7 inch
  '|' + // OR
  'Kindle Fire' + // Kindle Fire
  '|' + // OR
  'Silk' + // Kindle Fire, Silk Accelerated
  '|' + // OR
  'GT-P1000' + // Galaxy Tab 7 inch
    ')', // End non-capturing group
'i' // Case-insensitive matching
);

const match = (regex, userAgent) => regex.test(userAgent);
/**
 * IsMobile class
 */
class IsMobile {
  constructor(userAgent) {
    let ua = userAgent || navigator.userAgent;

    let tmp = ua.split('[FBAN');
    if (typeof tmp[1] !== 'undefined') {
      ua = tmp[0];
    }

    // Twitter mobile app's integrated browser on iPad adds a "Twitter for
    // iPhone" string. Same probable happens on other tablet platforms.
    // This will confuse detection so strip it out if it exists.
    tmp = ua.split('Twitter');
    if (typeof tmp[1] !== 'undefined') {
      ua = tmp[0];
    }

    this.ua = ua;
    this.np = navigator.platform;
    this.nt = navigator.maxTouchPoints;
  }

  get apple() {
    return {
      phone: match(applePhone, this.ua),
      ipod: match(appleIpod, this.ua),
      tablet:
        !match(applePhone, this.ua) && match(appleTablet, this.ua) ||
        (match(appleTablet, this.np) && !window.MSStream),
      device:
        match(applePhone, this.ua) ||
        match(appleIpod, this.ua) ||
        match(appleTablet, this.ua) ||
        (this.np === appleMacIntel && this.nt > 1 && !window.MSStream)
    };
  }

  get amazon() {
    return {
      phone: match(amazonPhone, this.ua),
      tablet: !match(amazonPhone, this.ua) && match(amazonTablet, this.ua),
      device: match(amazonPhone, this.ua) || match(amazonTablet, this.ua)
    };
  }

  get android() {
    return {
      phone: match(amazonPhone, this.ua) || match(androidPhone, this.ua),
      tablet:
        !match(amazonPhone, this.ua) &&
        !match(androidPhone, this.ua) &&
        (match(amazonTablet, this.ua) || match(androidTablet, this.ua)),
      device:
        match(amazonPhone, this.ua) ||
        match(amazonTablet, this.ua) ||
        match(androidPhone, this.ua) ||
        match(androidTablet, this.ua)
    };
  }

  get windows() {
    return {
      phone: match(windowsPhone, this.ua),
      tablet: match(windowsTablet, this.ua),
      device: match(windowsPhone, this.ua) || match(windowsTablet, this.ua)
    };
  }

  get other() {
    return {
      blackberry: match(otherBlackberry, this.ua),
      blackberry10: match(otherBlackberry10, this.ua),
      opera: match(otherOpera, this.ua),
      firefox: match(otherFirefox, this.ua),
      chrome: match(otherChrome, this.ua),
      device:
        match(otherBlackberry, this.ua) ||
        match(otherBlackberry10, this.ua) ||
        match(otherOpera, this.ua) ||
        match(otherFirefox, this.ua) ||
        match(otherChrome, this.ua)
    };
  }

  get sevenInch() {
    return match(sevenInch, this.ua);
  }

  get any() {
    return (
      this.apple.device ||
      this.android.device ||
      this.windows.device ||
      this.other.device ||
      this.seven_inch
    );
  }

  // excludes 'other' devices and ipods, targeting touchscreen phones
  get phone() {
    return this.apple.phone || this.android.phone || this.windows.phone;
  }

  // excludes 7 inch devices, classifying as phone or tablet is left to the user
  get tablet() {
    return this.apple.tablet || this.android.tablet || this.windows.tablet;
  }
}

export default new IsMobile(navigator.userAgent, navigator.platform);
